import React from "react";
import assetimages from "./common/assetimages";
import { errorToast, successToast } from "./common/showtoast";
import ApiRequest from "./common/restservice";
export default class ForgotPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: ""
    }
  }
  render() {
    return (
      <div style={{ background: `url(${assetimages.bg})`, backgroundRepeat: "no-repeat", backgroundSize: "cover" }}>
        <div className="d-flex align-items-center min-vh-100 py-3 py-md-0">
          <div className="container">
            <div className="card login-card col-lg-6 mx-auto" style={{ backgroundColor: "#f1fff0f2" }}>
              <div className="card-body">
                <div className="brand-wrapper text-center">
                  <img src={assetimages.logo} style={{height:100}} alt="logo" className="logo" />
                </div>
                <p className="login-card-description">Enter your username to start the password recovery.</p>

                <div>
                  <div className="form-group">
                    <label htmlFor="email" className="sr-only">Username</label>
                    <input type="email" name="email" id="email" className="form-control" placeholder="Username" onChange={(e) => {
                      this.setState({
                        email: e.target.value
                      })
                    }} value={this.state.email} />
                  </div>
                  <input name="login" id="login" className="btn btn-block login-btn mb-4" type="button" value="Get Password" onClick={async () => {
                    if (!this.state.email) {
                      errorToast("Enter valid email");
                      return;
                    }
                    let jsoninput = {
                      username: this.state.email
                    }
                    let res = await ApiRequest("ForgotPasswordMobile.asp", "POST", jsoninput);
                    if (res.status === "error") {
                      errorToast(res.message);
                      return;
                    }
                    successToast(res.message);
                    this.props.history.push("/login");
                  }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
